import './Nav.scss'
import { GoabAppHeaderMenu } from "@abgov/react-components";
import { useAuth } from 'react-oidc-context';
import { parseToken } from '../../utils/tokenUtil';
import { createNavTestId } from '../../utils/testIds';


export const Nav = () => {
  const auth = useAuth();
  const logout = () => {
     if (!auth.isLoading && auth.isAuthenticated) {
       auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
     }
  };
  return (
    
    <div style={{display: 'inline-block'}} data-testid={createNavTestId('container')}>
      {auth.isAuthenticated &&
        <>
          <GoabAppHeaderMenu data-testid={createNavTestId('user-menu')} heading={parseToken(auth.user?.id_token as string)?.email} leadingIcon="person-circle">
          {// eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a data-testid={createNavTestId('logout')} onClick={logout}>Log out</a> 
          }
          {// eslint-disable-next-line jsx-a11y/anchor-is-valid
            // <a onClick={() => { auth.signinSilent().then().catch()}}>Get new token</a> 
            <a data-testid={createNavTestId('refresh-token')}>Get new token</a> 
          }
          </GoabAppHeaderMenu>
        </>
      }
    </div>
  )
};

